/*
 * @Author: liuxw@codoon.com
 * @Date: 2020-07-02 17:16:34
 * @Last Modified by: liuxw@codoon.com
 * @Last Modified time: 2020-07-03 18:03:12
 * @Content:
 */

export default {
  rewardModal: {
    width: "292px",
    height: "fit-content",
    position: "absolute",
    top: "50%",
    backgroundColor: "#fff",
    borderRadius: "10px",
    left: "50%",
    transform: "translate(-50%,-50%)",
    fontSize: "PingFang SC Medium",
    overflow: "hidden",
  },
  closeBtn: {
    position: "absolute" as "absolute",
    width: "22px",
    height: "22px",
    top: "10px",
    right: "10px",
    backgroundImage: "url('https://fxd-cdn.codoon.com/static/upload/20210701/icon_activity_popup_close@2xsHgLL8.png')",
    backgroundSize: "cover",
    zIndex: 999
  },
  contentWrapper: {
    position: "relative" as "relative",
    paddingBottom: "20px",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
  },
  // 标题
  title: {
    paddingTop: "137px",
    fontSize: "20px",
    color: "#222222",
    textAlign: "center" as "center",
    fontWeight: 500,
    lineHeight: "28px",
  },
  // 限量奖品已发完
  sentOutInfoWrapper: {
    paddingTop: "30px",
    paddingBottom: "10px",
  },
  sentOuttProInfoWrapper: {
    paddingTop: "10px",
    paddingBottom: "10px"
  },
  sentOutInfo: {
    width: "242px",
    height: "45px",
    margin: "0 auto",
    borderRadius: "10px",
    border: "1px solid rgba(204,204,204,1)",
    lineHeight: "45px",
    color: "rgba(85,85,85,1)",
    fontWeight: 400,
    textAlign: "center" as "center",
    fontSize: "16px",
  },
  sentOutProInfo: {
    width: "100%",
    height: "35px",
    margin: "0 auto",
    borderRadius: "10px",
    border: "1px solid #CCCCCC",
    lineHeight: "35px",
    color: "rgba(85,85,85,1)",
    fontWeight: 400,
    textAlign: "center" as "center",
    fontSize: "14px",
  },
  // 奖励描述
  comment: {
    paddingTop: "20px",
    paddingLeft: "27px",
    whiteSpace: "pre-line" as "pre-line",
    paddingRight: "27px",
    fontSize: "14px",
    fontWeight: 400,
    color: "#555555",
    lineHeight: "20px",
    paddingBottom: "30px",
  },
  // 实物奖励
  addAddressBtn: {
    marginTop: "20px",
    width: "242px",
    height: "45px",
    lineHeight: "45px",
    margin: "0 auto",
    borderRadius: "10px",
    backgroundColor: "#00BC71",
    fontSize: "16px",
    color: "rgba(255,255,255,1)",
    textAlign: "center" as "center",
  },
  // 虚拟奖品
  virtualReward: {
    width: "246px",
    height: "20px",
    margin: "0 auto",
    display: "flex",
    overflow: "hidden",
    justifyContent: "center"
  },
  virtualPromotion: {
    width: "100%",
    margin: "0 auto",
    display: "flex",
    justifyContent: "flex-start",
    paddingRight: '6px',
    marginTop: '15px',
    marginBottom: '10px'
  },
  virtualPromotionCoupon: {
    lineHeight: "20px",
    fontSize: "14px",
    color: "#555555",
    whiteSpace: "nowrap" as "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    wordBreak: "break-all" as "break-all",
    flex: 1
  },
  virtualPromotionBtn: {
    width: "100%",
    height: "35px",
    background: "#00BC71",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "14px",
    fontWeight: 400,
    color: "#FFFFFF",
  },
  // 如果有虚拟奖品跳转链接
  virtualGetBtn: {
    width: "242px",
    height: "45px",
    lineHeight: "45px",
    margin: "0 auto 16px",
    backgroundColor: "#00BC71",
    borderRadius: "10px",
    textAlign: "center" as "center",
    fontSize: "16px",
    color: "#fff",
  },
  virtualRewardCoupon: {
    maxWidth: "208px",
    lineHeight: "20px",
    fontSize: "14px",
    color: "#555555",
    whiteSpace: "nowrap" as "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    wordBreak: "break-all" as "break-all",
  },
  virtualRewardBtn: {
    cursor: "pointer",
    // 比80多2px是为了解决border-radius渲染在plus、android上可能出现的空白边问题
    // width: "82px",
    // backgroundColor: "rgba(0,188,113,1)",
    // textAlign: "center" as "center",
    lineHeight: "20px",
    fontSize: "14px",
    color: "#00BC71",
    marginLeft: "6px"
  },
  // 奖品限额
  footerComment: {
    textAlign: "center" as "center",
    fontSize: "14px",
    color: "#B3B3B3",
    lineHeight: "20px",
    paddingTop: "20px",
  },
  entityTitle: {
    paddingTop: "120px",
    fontSize: "20px",
    color: "#222222",
    textAlign: "center" as "center",
    fontWeight: 500,
    lineHeight: "28px",
  },
  entityItem: {
    padding: "0 25px",
    borderTop: '1px solid #E6E6E6',
    marginTop: '20px',
    paddingTop: '20px'
  },
  entityItemFirst: {
    padding: "0 25px",
    paddingTop: '20px'
  },
  entitylabel: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    marginBottom: "10px",
  },
  entityIcon: {
    width: "12px",
    height: "12px",
    display: "block",
    marginRight: "10px"
  },
  entityDesc: {
    fontSize: "13px",
    color: "#555555",
    fontWeight: 400
  },
  entityInfo: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: "35px"
  },
  entityName: {
    fontSize: "14px",
    fontWeight: 500,
    color: "#00BC71",
    whiteSpace: "nowrap" as "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    wordBreak: "break-all" as "break-all",
    marginRight: "3px",
    flex: '1'
  },
  entityBtn: {
    width:"77px",
    height: "35px",
    background: "#00BC71",
    borderRadius: "10px",
    fontSize: "14px",
    fontWeight: 400,
    color: "#FFFFFF",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  entityFoComment: {
    fontSize: '12px',
    fontWeight: 400,
    color: '#B3B3B3'
  },
  couponCode: {

  }
};
